module.exports = __webpack_public_path__ + "static/media/jewelish.9a9a85e1.png";